import V2 from "./v2/landing";

export default function Entry(props) {
    return <V2 {...props} />;
}
